export function noop() {}

export function rejector(value) {
    return () => Promise.reject(value);
}
